var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwitch28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8943 8.21483C21.4268 8.84944 22.373 8.93221 23.0076 8.39971C23.6422 7.86721 23.725 6.92107 23.1925 6.28646C18.9324 1.20957 11.3634 0.547358 6.28648 4.80738C5.73997 5.26595 5.24417 5.76345 4.79999 6.29256V3.99997C4.79999 3.17155 4.12841 2.49997 3.29999 2.49997C2.47156 2.49997 1.79999 3.17155 1.79999 3.99997V9.99997C1.79999 10.8284 2.47156 11.5 3.29999 11.5H9.29999C10.1284 11.5 10.8 10.8284 10.8 9.99997C10.8 9.17155 10.1284 8.49997 9.29999 8.49997H6.87319C7.26085 7.99882 7.70819 7.53064 8.21484 7.10551C12.0225 3.9105 17.6993 4.40715 20.8943 8.21483Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.10567 19.7851C6.57317 19.1505 5.62703 19.0677 4.99242 19.6002C4.35781 20.1327 4.27503 21.0789 4.80754 21.7135C9.06756 26.7904 16.6366 27.4526 21.7135 23.1926C22.26 22.734 22.7558 22.2365 23.2 21.7074V24C23.2 24.8284 23.8716 25.5 24.7 25.5C25.5284 25.5 26.2 24.8284 26.2 24V18C26.2 17.1715 25.5284 16.5 24.7 16.5L18.7 16.5C17.8716 16.5 17.2 17.1715 17.2 18C17.2 18.8284 17.8716 19.5 18.7 19.5H21.1268C20.7392 20.0011 20.2918 20.4693 19.7852 20.8944C15.9775 24.0894 10.3007 23.5928 7.10567 19.7851Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch28);
export default __webpack_public_path__ + "static/media/switch_28.ad3d0ba5.svg";
export { ForwardRef as ReactComponent };